import { KnownDocumentActionIdPrefix } from '@office-start/document-types';
export function getInstrumentedActionId(id) {
    var instrumentedActionId = undefined;
    if (!!KnownDocumentActionIdPrefix[id]) {
        instrumentedActionId = id;
    }
    else if (id.indexOf(KnownDocumentActionIdPrefix.openInApp) === 0) {
        instrumentedActionId = KnownDocumentActionIdPrefix.openInApp;
    }
    else if (id.indexOf(KnownDocumentActionIdPrefix.openInBrowser) === 0) {
        // OfficeHome logs this as 'open'
        instrumentedActionId = KnownDocumentActionIdPrefix.openInBrowser;
    }
    return instrumentedActionId;
}
//# sourceMappingURL=getInstrumentedActionId.js.map